import { ENOPCaseStatus } from '../../enums';

export const caseStatusMap: Record<ENOPCaseStatus, string> = {
  [ENOPCaseStatus.None]: ENOPCaseStatus.None,
  [ENOPCaseStatus.Draft]: ENOPCaseStatus.Draft,
  [ENOPCaseStatus.TXCenterDraft]: ENOPCaseStatus.TXCenterDraft,
  [ENOPCaseStatus.ClinicalScreening]: 'Clinical Screening',
  [ENOPCaseStatus.Declined]: 'Case Declined',
  [ENOPCaseStatus.PendingLogistics]: 'Pending Logistics',
  [ENOPCaseStatus.ResourceDeployed]: 'Resources Deployed',
  [ENOPCaseStatus.ResourcesBooked]: 'Resources Assigned',
  [ENOPCaseStatus.AtDonorHospital]: 'At Donor Hospital',
  [ENOPCaseStatus.OrganOnOCS]: 'On OCS',
  [ENOPCaseStatus.DeployedToTXCenter]: 'In Transit',
  [ENOPCaseStatus.AtTXCenter]: 'At TX Center',
  [ENOPCaseStatus.OrganOffOCS]: 'Off OCS',
  [ENOPCaseStatus.ServiceCompleted]: 'Service Completed',
  [ENOPCaseStatus.ServiceDeclined]: 'Not Completed',
  [ENOPCaseStatus.ReturningToBase]: 'Returning to Base',
  [ENOPCaseStatus.Finished]: ENOPCaseStatus.Finished,
  [ENOPCaseStatus.Closed]: 'Case Closed',
  [ENOPCaseStatus.Accepted]: 'Case Accepted',
  [ENOPCaseStatus.New]: ENOPCaseStatus.New,
  [ENOPCaseStatus.OrTimeConfirmed]: ENOPCaseStatus.OrTimeConfirmed,
  [ENOPCaseStatus.Deleted]: ENOPCaseStatus.Deleted,
};

type ShortStatusKeys =
  | ENOPCaseStatus.ClinicalScreening
  | ENOPCaseStatus.PendingLogistics
  | ENOPCaseStatus.Accepted;

export const caseStatusMapShort: Record<ShortStatusKeys, string> = {
  [ENOPCaseStatus.ClinicalScreening]: 'CSCR',
  [ENOPCaseStatus.PendingLogistics]: 'PENL',
  [ENOPCaseStatus.Accepted]: 'ACPT',
};

export const NEW_CASES_ROTATION_GROUP = 'NewCasesGroup';

export const ACTIVE_CASE_STATUSES = [
  ENOPCaseStatus.ResourcesBooked,
  ENOPCaseStatus.ResourceDeployed,
  ENOPCaseStatus.AtDonorHospital,
  ENOPCaseStatus.OrganOnOCS,
  ENOPCaseStatus.DeployedToTXCenter,
  ENOPCaseStatus.AtTXCenter,
  ENOPCaseStatus.OrganOffOCS,
  ENOPCaseStatus.ServiceCompleted,
  ENOPCaseStatus.ServiceDeclined,
  ENOPCaseStatus.ReturningToBase,
];

export const CASE_ROTATION_ORDER: CaseRotationStatus[] = [
  NEW_CASES_ROTATION_GROUP,
  ...ACTIVE_CASE_STATUSES.filter((status): status is TrackedCaseStatuses =>
    [
      ENOPCaseStatus.ResourcesBooked,
      ENOPCaseStatus.ResourceDeployed,
      ENOPCaseStatus.AtDonorHospital,
      ENOPCaseStatus.OrganOnOCS,
      ENOPCaseStatus.DeployedToTXCenter,
      ENOPCaseStatus.AtTXCenter,
      ENOPCaseStatus.OrganOffOCS,
      ENOPCaseStatus.ServiceCompleted,
      ENOPCaseStatus.ServiceDeclined,
    ].includes(status),
  ),
];

export type CaseRotationStatus =
  | TrackedCaseStatuses
  | typeof NEW_CASES_ROTATION_GROUP;

export const OFF_OCS_STATUSES: CaseRotationStatus[] = [
  ENOPCaseStatus.OrganOffOCS,
  ENOPCaseStatus.ServiceCompleted,
  ENOPCaseStatus.ServiceDeclined,
];

export const caseRotationStatusMap: Record<CaseRotationStatus, string> = {
  [NEW_CASES_ROTATION_GROUP]: 'New',
  [ENOPCaseStatus.ResourcesBooked]: 'Res. Assigned',
  [ENOPCaseStatus.ResourceDeployed]: 'Res. Deployed',
  [ENOPCaseStatus.AtDonorHospital]: 'Donor OR',
  [ENOPCaseStatus.OrganOnOCS]: 'On OCS',
  [ENOPCaseStatus.DeployedToTXCenter]: 'In Transit',
  [ENOPCaseStatus.AtTXCenter]: 'At TXC',
  [ENOPCaseStatus.OrganOffOCS]: 'Off OCS',
  [ENOPCaseStatus.ServiceCompleted]: 'Off OCS',
  [ENOPCaseStatus.ServiceDeclined]: 'Off OCS',
  [ENOPCaseStatus.ReturningToBase]: 'Return to Base',
};
export type TrackedCaseStatuses =
  | ENOPCaseStatus.ResourcesBooked
  | ENOPCaseStatus.ResourceDeployed
  | ENOPCaseStatus.AtDonorHospital
  | ENOPCaseStatus.OrganOnOCS
  | ENOPCaseStatus.DeployedToTXCenter
  | ENOPCaseStatus.AtTXCenter
  | ENOPCaseStatus.OrganOffOCS
  | ENOPCaseStatus.ServiceCompleted
  | ENOPCaseStatus.ServiceDeclined
  | ENOPCaseStatus.ReturningToBase;
